import React from 'react'
import SimpleBanner from '../../Screens/Common/SimpleBanner'
import GetInTouch from '../../Components/Offers/GetInTouch'
import AboutUs_banner from '../../Assets/home/BannerImage.png'
import OurOffers from '../../Components/Offers/OurOffers'
import BookYourService from '../../Components/Common/BookYourService'

const Offers = () => {
  return (
    <div className='overflow-hidden'>
      <SimpleBanner
        image={AboutUs_banner}
        name="Offers"
        path="Home >> Offers"
      />
      <OurOffers />
      <GetInTouch />
      <BookYourService />
    </div>
  )
}

export default Offers